/**
 * Filled left → right: complete (green / dark: black). Remainder: incomplete (red / dark: white).
 * Glowing divider at the completion frontier (blue light, silver dark).
 */
export function SalesDailyChecklistProgressTrack({ pct }: { pct: number }) {
  const safe = Math.min(100, Math.max(0, pct));
  const showEdge = safe > 0 && safe < 100;

  return (
    <div
      className="relative h-3.5 w-full overflow-hidden rounded-full border border-gray-300/90 dark:border-white/20"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={safe}
      aria-valuetext={`${safe}% complete`}
    >
      <div className="absolute inset-0 flex flex-row">
        <div
          className="h-full bg-emerald-500 dark:bg-black transition-[width] duration-500 ease-out motion-reduce:transition-none"
          style={{ width: `${safe}%` }}
        />
        <div
          className="h-full bg-red-400 dark:bg-white transition-[width] duration-500 ease-out motion-reduce:transition-none"
          style={{ width: `${100 - safe}%` }}
        />
      </div>
      {showEdge ? (
        <div
          className="pointer-events-none absolute top-0 z-10 h-full w-px -translate-x-1/2 bg-blue-500 shadow-[0_0_10px_3px_rgba(59,130,246,0.75)] dark:bg-slate-200 dark:shadow-[0_0_14px_4px_rgba(226,232,240,0.85)]"
          style={{ left: `${safe}%` }}
          aria-hidden
        />
      ) : null}
    </div>
  );
}
